import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kndla_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function fmtErr(e, fallback = "Something went wrong. Try again.") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || "").filter(Boolean).join(" ");
  return e?.message || fallback;
}

let settingsPromise = null;
export function getSettings() {
  if (!settingsPromise) {
    settingsPromise = api
      .get("/settings")
      .then((r) => r.data)
      .catch(() => ({ telegram_handle: "KNDLA101" }));
  }
  return settingsPromise;
}

export function fmtDate(iso, locale = "en-GB") {
  if (!iso) return "";
  const d = new Date(`${iso}T00:00:00`);
  return d.toLocaleDateString(locale, { weekday: "short", day: "numeric", month: "short" });
}

export function fmtDayNum(iso) {
  if (!iso) return "";
  return new Date(`${iso}T00:00:00`).getDate();
}

export function fmtMonth(iso, locale = "en-GB") {
  if (!iso) return "";
  return new Date(`${iso}T00:00:00`).toLocaleDateString(locale, { month: "short" }).toUpperCase().replace(".", "");
}
